export interface ICurrentLocationService {
    getLocationId(): string | undefined;
}

export class CurrentLocationService {
    private static instance: ICurrentLocationService;

    public static init(currentLocationService: ICurrentLocationService) {
        CurrentLocationService.instance = currentLocationService;
    }

    public static getLocationId(): string | undefined {
        const locationId = CurrentLocationService.instance?.getLocationId();
        return locationId;
    }
}
